import { BundledProductContactRecord } from 'cpfr-common';
import { AbstractContentState } from '@cp-shared-19/frontend-integration';
import { RootState } from 'store/rootReducer';

export const BundledProductContentSelector = (state: RootState): AbstractContentState<BundledProductContactRecord[]> =>
    state.content.bundledProductsContactInfo;
